<script setup lang="ts">
import { TabsList, TabsRoot, TabsTrigger } from 'reka-ui';
import {
  EVENT_VIEW_MODES,
  type EventViewMode,
} from '~/shared/lib/events-routes.const';

defineProps<{
  active: EventViewMode;
}>();

const emit = defineEmits<{
  change: [value: EventViewMode];
}>();

const tabs = [
  { key: EVENT_VIEW_MODES.afisha, label: 'Афиша', enabled: true },
  { key: EVENT_VIEW_MODES.media, label: 'Фото- и видеоотчеты', enabled: true },
  {
    key: EVENT_VIEW_MODES.schedule,
    label: 'График мероприятий',
    enabled: true,
  },
];
</script>

<template>
  <TabsRoot
    :model-value="active"
    :class="$style.tabs"
    @update:model-value="emit('change', $event as EventViewMode)"
  >
    <TabsList aria-label="Режим просмотра мероприятий" :class="$style.list">
      <TabsTrigger
        v-for="tab in tabs"
        :key="tab.key"
        as="div"
        :value="tab.key"
        :disabled="!tab.enabled"
        :class="$style.tab"
      >
        {{ tab.label }}
      </TabsTrigger>
    </TabsList>
  </TabsRoot>
</template>

<style module lang="scss">
.tabs {
  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-gray-line);
}

.list {
  display: flex;
  align-items: center;
  padding: 0 var(--space-2-5x);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.tab {
  @include text_body2_medium;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  padding: var(--space-2x) var(--space-2-5x);
  color: var(--color-black-1);
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  white-space: nowrap;
  transition:
    color 0.2s,
    border-color 0.2s;

  &:hover {
    color: var(--color-yellow-2);
  }

  &[data-state='active'] {
    height: 66px;
    color: var(--color-yellow-2);
    border-bottom-color: var(--color-yellow-2);
  }

  @media (max-width: 599px) {
    padding: 12px;
  }

  &[data-disabled] {
    color: var(--color-gray-text);
    cursor: default;
    opacity: 0.5;

    &:hover {
      color: var(--color-gray-text);
    }
  }
}
</style>
